import { createSlice } from '@reduxjs/toolkit'
import {getInteractions, getInteractionsPag} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  interactionsPag: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: []
  },
  interactions: [], 
  loading: "idle",
  error: null }

const interactionsSlice = createSlice({
  name: 'interactions',
  initialState,
  reducers: {
      clearInteractionsError: (state)=>{
          state.error = null
          state.loading = "idle"
    }
  },
  extraReducers: {
      [getInteractionsPag.pending]: (state) => {
          state.loading = "loading"; 
          state.error = null
      },
      [getInteractionsPag.fulfilled]: (state, action) => {
          state.loading = "succeeded";
          state.interactionsPag.elements = action.payload.elements
          state.interactionsPag.pageIndex = action.payload.pageIndex;
          state.interactionsPag.totalRecords = action.payload.totalRecords;
          state.interactionsPag.totalPages = action.payload.totalPages;
          state.interactionsPag.pageSize = action.payload.pageSize;
          state.interactionsPag.hasPreviousPage = action.payload.hasPreviousPage;
          state.interactionsPag.hasNextPage = action.payload.hasNextPage
      
    },
      [getInteractionsPag.rejected]: (state, action) => {
          state.loading = "failed"; 
          state.error = action.error.message
      },
      [getInteractions.pending]:(state)=>{
        state.loading = "loading";
        state.error = null
      },
      [getInteractions.fulfilled]:(state, action)=>{
        state.loading = "succeeded";
        state.interactions = action.payload;
      },
      [getInteractions.rejected]: (state, action)=>{
          state.loading = "failed"; 
          state.error = action.error.message
      },
      [logOut]: (state)=> initialState
  }
})

export const {clearInteractionsError} = interactionsSlice.actions;
export default interactionsSlice.reducer
